<template>
  <b-row>
    <b-col md="4">
      <InputSelectTyping
        ref="matriculaId"
        v-model="formularioFiltro.matriculaId"
        :options="opcoes.matriculas"
        :label="$t('FINANCEIRO.BUSCAR_NOME_CODIGO_MATRICULA')"
        placeholder="GERAL.DIGITE_OU_PROCURE"
        @pesquisa-nome="buscaMatriculasPorNome"
        :loading="loadingMatricula"
      />
    </b-col>
    <b-col md="4">
      <input-select-multiple
        ref="statusPagamentoId"
        v-model="formularioFiltro.statusPagamentoId"
        :label="$t('FINANCEIRO_CONTAS_PAGAR.STATUS')"
        placeholder="FINANCEIRO_CONTAS_PAGAR.STATUS_PLACEHOLDER"
        :options="opcoes.statusPagamento"
        :loading="loadingStatus"
      />
    </b-col>
    <b-col md="4">
      <input-select-multiple
        ref="historicoLancamentoId"
        v-model="formularioFiltro.historicoLancamentoId"
        :label="$t('FINANCEIRO_CONTAS_RECEBER.HISTORICO')"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DIGITE_OU_PROCURE"
        :options="opcoes.historicos"
        :loading="loadingHistorico"
      />
    </b-col>
    <b-col md="5" class="mt-3">
      <input-select-multiple
        ref="contratoId"
        v-model="formularioFiltro.contratoId"
        :label="$t('FINANCEIRO.CONTRATOS_DESTA_MATRICULA')"
        :placeholder="placeholderContrato"
        :options="opcoes.contratos"
        :loading="loadingContrato"
        :disabled="desabilitar.contrato"
      />
    </b-col>
    <b-col md="4" class="mt-3">
      <input-select-multiple
        ref="contaId"
        v-model="formularioFiltro.contaId"
        :label="$t('FINANCEIRO_CONTAS_RECEBER.CONTA')"
        :options="opcoes.contas"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DIGITE_OU_PROCURE"
        :loading="loadingConta"
      />
    </b-col>
    <b-col md="3" class="mt-3">
      <input-text
        ref="codigo"
        v-model="formularioFiltro.codigo"
        type="text"
        label="FINANCEIRO_CONTAS_PAGAR.DOCUMENTO"
        placeholder="FINANCEIRO_CONTAS_PAGAR.DOCUMENTO_PLACEHOLDER"
      />
    </b-col>
    <!-- Filtros avançados -->

    <!-- data de lançamento -->
    <b-col md="4" v-if="exibirBuscaAvancada">
      {{ $t('FINANCEIRO_CONTAS_RECEBER.DATA_LANCAMENTO') }}
      <hr />
      <input-date-only-btn
        v-model="formularioFiltro.dataLancamentoInicio"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_INICIAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
      <input-date-only-btn
        v-model="formularioFiltro.dataLancamentoAte"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_FINAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
    </b-col>

    <!-- data de pagamento -->
    <b-col md="4" v-if="exibirBuscaAvancada">
      {{ $t('FINANCEIRO_CONTAS_RECEBER.DATA_PAGAMENTO') }}
      <hr />
      <input-date-only-btn
        v-model="formularioFiltro.dataPagamentoInicio"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_INICIAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
      <input-date-only-btn
        v-model="formularioFiltro.dataPagamentoAte"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_FINAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
    </b-col>

    <!-- data de vencimento -->
    <b-col md="4" v-if="exibirBuscaAvancada">
      {{ $t('FINANCEIRO_CONTAS_RECEBER.DATA_VENCIMENTO') }}
      <hr />
      <input-date-only-btn
        v-model="formularioFiltro.dataVencimentoInicio"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_INICIAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
      <input-date-only-btn
        v-model="formularioFiltro.dataVencimentoAte"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_FINAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
    </b-col>

    <b-col md="auto" class="d-md-flex align-items-md-center">
      <input-checkbox
        variant="primary"
        class="botao-acao-filtro my-3 w-100"
        :label="$t('FINANCEIRO_CONTAS_RECEBER.OCULTAR_TITULOS_CONTRATOS_CANCELADOS')"
        v-model="formularioFiltro.ocultarTitulosDeContratosCancelados"
      />
    </b-col>

    <b-col md="auto" class="d-md-flex align-items-md-center">
      <input-checkbox
        variant="primary"
        class="botao-acao-filtro my-3 w-100"
        :label="$t('GERAL.BUSCA_AVANCADA')"
        v-model="exibirBuscaAvancada"
        @change="limparFiltrosAvancados"
      />
    </b-col>

    <b-col md="auto">
      <b-button
        variant="primary"
        class="botao-acao-filtro mb-3 w-100"
        @click="filtrarPor"
      >
        {{ $t('GERAL.FILTRAR') }}
      </b-button>
    </b-col>

    <b-col md="auto">
      <b-button
        variant="primary"
        class="botao-acao-filtro mb-3 w-100"
        @click="gerarExtrato"
        v-if="podeVisualizar"
        :disabled="desabilitarGerarExtrato"
      >
        {{ $t('FINANCEIRO_CONTAS_RECEBER.GERAR_EXTRATO') }}
      </b-button>
    </b-col>

    <b-col md="auto">
      <b-button
        variant="secondary"
        class="botao-acao-filtro mb-3 w-100"
        @click="limparFiltro"
      >
        {{ $t('GERAL.LIMPAR') }}
      </b-button>
    </b-col>

    <!-- ações e relatórios  -->
    <b-col md="auto" v-if="exibirBotoesRelatorios">
      <b-button
        variant="info"
        class="botao-acao-filtro mb-3 w-100"
        @click.prevent="gerarBoleto"
        :disabled="disabled.gerarBoleto"
        v-if="podeVisualizar"
      >
        {{ $t('FINANCEIRO_CONTAS_RECEBER.GERAR_BOLETO') }}
      </b-button>
    </b-col>
    <b-col md="auto" v-if="exibirBotoesRelatorios">
      <b-button
        variant="info"
        class="botao-acao-filtro mb-3 w-100"
        @click.prevent="baixarTitulo"
        :disabled="BtnBaixarTitulo"
        v-if="podeEditar"
      >
        {{ $t('FINANCEIRO_CONTAS_RECEBER.BAIXAR_TITULO') }}
      </b-button>
    </b-col>
    <b-col md="auto" v-if="exibirBotoesRelatorios">
      <b-button
        variant="info"
        class="botao-acao-filtro mb-3 w-100"
        @click.prevent="estornar"
        :disabled="disabled.fazerEstorno"
        v-if="podeEditar"
      >
        {{ $t('FINANCEIRO_CONTAS_RECEBER.ESTORNAR_TITULO') }}
      </b-button>
    </b-col>
    <b-col md="auto" v-if="exibirBotoesRelatorios">
      <b-button
        variant="info"
        class="botao-acao-filtro mb-3 w-100"
        @click="cancelarTitulo"
        :disabled="disabled.cancelar"
        v-if="podeEditar"
      >
        {{ $t('FINANCEIRO.CANCELAR_TITULO') }}
      </b-button>
    </b-col>
    <b-col md="auto" v-if="exibirBotoesRelatorios">
      <b-button
        variant="info"
        class="botao-acao-filtro mb-3 w-100"
        @click="cancelarBoleto"
        :disabled="disabled.cancelarBoleto"
        v-if="podeEditar"
      >
        {{ $t('FINANCEIRO.CANCELAR_BOLETO') }}
      </b-button>
    </b-col>
    <b-col md="auto" v-if="exibirBotoesRelatorios">
      <b-button
        variant="info"
        class="botao-acao-filtro mb-3 w-100"
        @click.prevent="portalLiberar"
        :disabled="disabled.liberarPortal"
        v-b-tooltip.hover
        :title="$t('FINANCEIRO.BTN_LIBERAR_PORTAL_EXPLICACAO')"
        v-if="podeEditar"
      >
        {{ $t('FINANCEIRO_CONTAS_RECEBER.LIBERAR_PORTAL') }}
      </b-button>
    </b-col>
    <b-col md="auto" v-if="exibirBotoesRelatorios">
      <b-button
        variant="info"
        class="botao-acao-filtro mb-3 w-100"
        @click.prevent="portalBloquear"
        :disabled="disabled.bloquearPortal"
        v-b-tooltip.hover
        :title="$t('FINANCEIRO.BTN_BLOQUEAR_PORTAL_EXPLICACAO')"
        v-if="podeEditar"
      >
        {{ $t('FINANCEIRO_CONTAS_RECEBER.BLOQUEAR_PORTAL') }}
      </b-button>
    </b-col>
    <b-col md="auto" v-if="exibirBotoesRelatorios">
      <b-button
        variant="info"
        class="botao-acao-filtro mb-3 w-100"
        @click="reimpressao"
        :disabled="disabled.reimpressao"
        v-if="podeVisualizar"
      >
        {{ $t('FINANCEIRO.REIMPRESSAO') }}
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
// Utils & Aux:
import mensagem from '@/common/utils/mensagem';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import ContaReceberService from '@/common/services/conta-receber/contaReceber.service.js';
import ContaService from '@/common/services/conta/conta.service';
import ContratosService from '@/common/services/contratos/contratos.service.js';
import MatriculaService from '@/common/services/matriculas/matriculas.service.js';

import { InputDateOnlyBtn } from '@/components/inputs';

// Components:
import {
  InputSelectMultiple,
  InputCheckbox,
  InputText,
  InputSelectTyping,
} from '@/components/inputs';

export default {
  mixins: [Permissoes],
  props: {
    exibirBotoesRelatorios: { type: Boolean, default: true },
    matriculasIguais: { type: Boolean, default: false },
    disabled: { type: Object, default: Object },
    filtroAntigo: { type: Object, default: () => {} },
  },
  components: {
    InputDateOnlyBtn,
    InputCheckbox,
    InputText,
    InputSelectMultiple,
    InputSelectTyping,
  },
  data() {
    return {
      desabilitarGerarExtrato: true,
      limpar: false,
      loadingConta: false,
      loadingStatus: false,
      loadingHistorico: false,
      loadingMatricula: false,
      loadingContrato: false,
      formularioFiltro: {
        matriculaId: null,
        contratoId: null,
        codigo: null,
        ocultarTitulosDeContratosCancelados: true,
      },
      opcoes: {
        contas: [],
        historicos: [],
        statusPagamento: [],
        contratos: [],
        matriculas: [],
      },
      desabilitar: {
        contrato: true,
      },
      exibirBuscaAvancada: false,
      filtroRepasse: [
        'codigo',
        'fornecedorId',
        'documento',
        'statusPagamentoId',
        'contaId',
        'historicoLancamentoId',
        'matriculaId',
        'contratoId',

        'dataPagamentoAte',
        'dataPagamentoInicio',

        'dataLancamentoAte',
        'dataLancamentoInicio',

        'dataVencimentoAte',
        'dataVencimentoInicio',
      ],
      filtroAvancadoRepasse: [
        'dataPagamentoAte',
        'dataPagamentoInicio',

        'dataLancamentoAte',
        'dataLancamentoInicio',

        'dataVencimentoAte',
        'dataVencimentoInicio',
      ],
    };
  },
  computed: {
    habilitarFiltragem() {
      return Object.values(this.formularioFiltro).some(
        (value) => value !== null && value !== undefined && value !== ''
      );
    },
    BtnBaixarTitulo() {
      return this.matriculasIguais ? this.disabled.baixarTitulo : true;
    },
    placeholderContrato() {
      return this.desabilitar.contrato
        ? 'GERAL.SELECIONE_MATRICULA_PARA_HABILITAR'
        : this.opcoes.contratos.length
        ? 'GERAL.DIGITE_OU_PROCURE'
        : 'GERAL.SEM_CONTRATOS_CADASTRADOS';
    },
  },
  watch: {
    'filtroAntigo.codigo'() {
      if (this.filtroAntigo?.codigo) {
        this.formularioFiltro.codigo = this.filtroAntigo?.codigo;
      }
    },
    'filtroAntigo.matriculaId'() {
      if (this.filtroAntigo?.matriculaId) {
        this.buscaMatriculaFiltroAntigo(this.filtroAntigo?.matriculaId);
      }
    },
    'formularioFiltro.matriculaId'() {
      this.formularioFiltro.contratoId = null;
      if (this.formularioFiltro.matriculaId) {
        this.getContratos();
      } else {
        this.opcoes.contratos = [];
        this.desabilitar.contrato = true;
      }
      this.desabilitar.contrato = false;
    },
    formularioFiltro() {
      this.validarFiltragem();
    },
  },
  mounted() {
    this.getContas();
    this.getStatusPagamento();
    this.getHistoricoContaReceber();
  },
  methods: {
    buscaMatriculaFiltroAntigo(id) {
      this.loadingMatricula = true;
      MatriculaService.buscarPorId(id)
        .then(({ data }) => {
          this.formularioFiltro.matriculaId = data.id;
          this.opcoes.matriculas = [data];
          this.opcoes.matriculas[0].text = `${data.codigoMatricula} - ${data.nome}`;
          this.opcoes.matriculas[0].value = data.id;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingMatricula = false;
        });
    },
    buscaMatriculasPorNome(nome) {
      this.loadingMatricula = true;
      MatriculaService.buscarTodosPorNomeCodigo(nome)
        .then((data) => {
          if (data.itens.length) {
            this.opcoes.matriculas = data.itens;
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingMatricula = false;
        });
    },
    validaFiltroAntigoContrato() {
      if (this.filtroAntigo?.contratoId) {
        this.opcoes.contratos.forEach((item) => {
          if (item.value == this.filtroAntigo.contratoId) {
            this.formularioFiltro.contratoId = item;
          }
        });
      }
    },
    getContratos() {
      this.formularioFiltro.contratoId = {};
      this.loadingContrato = true;
      ContratosService.buscarContratoPorMatriculaId(
        this.formularioFiltro.matriculaId
      )
        .then((contratos) => {
          this.opcoes.contratos = contratos;
          this.desabilitar.contrato = false;

          this.validaFiltroAntigoContrato();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingContrato = false;
        });
    },
    validaFiltroAntigoConta() {
      if (this.filtroAntigo?.contaId) {
        this.opcoes.contas.forEach((item) => {
          if (item.value == this.filtroAntigo.contaId) {
            this.formularioFiltro.contaId = item;
          }
        });
      }
    },
    getContas() {
      this.loadingConta = true;
      ContaService.obterTodasSemPaginacao()
        .then(({ data }) => {
          this.opcoes.contas = data;

          this.validaFiltroAntigoConta();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingConta = false;
        });
    },
    validaFiltroAntigoStatus() {
      if (this.filtroAntigo?.statusPagamentoId) {
        this.opcoes.statusPagamento.forEach((item) => {
          if (item.value == this.filtroAntigo.statusPagamentoId) {
            this.formularioFiltro.statusPagamentoId = item;
          }
        });
      }
    },
    getStatusPagamento() {
      this.loadingStatus = true;
      ContaReceberService.buscarStatusPagamento()
        .then((data) => {
          data = data.map((row) => ({
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.statusPagamento = data;

          this.validaFiltroAntigoStatus();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    validaFiltroAntigoHistorico() {
      if (this.filtroAntigo?.historicoLancamentoId) {
        this.opcoes.historicos.forEach((item) => {
          if (item.value == this.filtroAntigo.historicoLancamentoId) {
            this.formularioFiltro.historicoLancamentoId = item;
          }
        });
      }
    },
    getHistoricoContaReceber() {
      this.loadingHistorico = true;
      ContaReceberService.buscarHistoricoContaReceber()
        .then((data) => {
          data = data.map((row) => ({
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.historicos = data;

          this.validaFiltroAntigoHistorico();
        })
        .catch((err) => {
          mensagem.erro(this.$t('GERAL.ERRO'), err.response.data.errors);
        })
        .finally(() => {
          this.loadingHistorico = false;
        });
    },
    criarObjetoParaFiltro() {
      return this.filtroRepasse.reduce((acc, string) => {
        acc[string] = this.formularioFiltro[string]?.value;
        return acc;
      }, {});
    },
    criarObjetoParaDeFiltroAvancado() {
      return this.filtroAvancadoRepasse.reduce((acc, string) => {
        acc[string] = this.formularioFiltro[string];
        return acc;
      }, {});
    },
    filtrarPor() {
      let filtro = this.criarObjetoParaFiltro();
      let filtroAvancado = this.criarObjetoParaDeFiltroAvancado();

      let filtros = {
        codigo: this.formularioFiltro?.codigo,
        matriculaId: this.formularioFiltro?.matriculaId,
        ocultarTitulosDeContratosCancelados:
          this.formularioFiltro?.ocultarTitulosDeContratosCancelados,
        ...filtro,
        ...filtroAvancado,
      };
      filtros.codigo = this.formularioFiltro?.codigo;
      filtros.matriculaId = this.formularioFiltro?.matriculaId;
      this.$emit('resultado-filtro', filtros);
    },

    limparFiltrosAvancados() {
      if (this.formularioFiltro.dataVencimentoInicio)
        delete this.formularioFiltro.dataVencimentoInicio;
      if (this.formularioFiltro.dataVencimentoAte)
        delete this.formularioFiltro.dataVencimentoAte;

      if (this.formularioFiltro.dataPagamentoInicio)
        delete this.formularioFiltro.dataPagamentoInicio;
      if (this.formularioFiltro.dataPagamentoAte)
        delete this.formularioFiltro.dataPagamentoAte;

      if (this.formularioFiltro.dataLancamentoInicio)
        delete this.formularioFiltro.dataLancamentoInicio;
      if (this.formularioFiltro.dataLancamentoAte)
        delete this.formularioFiltro.dataLancamentoAte;

      this.validarFiltragem();
    },

    validarFiltragem() {
      this.desabilitarGerarExtrato = !this.habilitarFiltragem;
    },

    limparFiltro() {
      this.formularioFiltro = { ocultarTitulosDeContratosCancelados: true };
      this.limpar = !this.limpar;
      this.validarFiltragem();
      this.$emit('limpar');
    },

    // RELATORIOS
    gerarBoleto() {
      this.$emit('gerar-boletos');
    },
    baixarTitulo() {
      this.$emit('baixar-titulo');
    },
    cancelarTitulo() {
      this.$emit('cancelar-conta');
    },
    cancelarBoleto() {
      this.$emit('cancelar-boleto');
    },
    estornar() {
      this.$emit('estornar');
    },
    portalLiberar() {
      this.$emit('portal-liberar');
    },
    portalBloquear() {
      this.$emit('portal-bloquear');
    },
    reimpressao() {
      this.$emit('reimpressao');
    },
    gerarExtrato() {
      this.$emit('gerar-extrato', this.formularioFiltro);
    },
  },
};
</script>
